import ClientComponent from "./components/ClientComponent.js"
window.ClientComponent = ClientComponent;